import React from "react";

export const getProductImage = (type) => {
  const images = {
    'flower': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/avatars/avatar-34.png',
    'edible': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/851d647a5cca477aa678f2ef86c20032_edible.webp',
    'cart': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/avatars/avatar-37.png', 
    'cartridge': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/avatars/avatar-37.png',
    'vape': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/avatars/avatar-37.png',
    'pre-roll': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/avatars/avatar-35.png',
    'concentrate': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/d8b23f1b0e354b6ea19edafd8c78fd39_dabs.webp',
    'topical': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/85cdbecb266840b3a07cca49c2592a43_topical.webp',
    'tincture': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/5fd1745690ee4e9680b51b81917f0a28_tincture.png',
    'default': 'https://highmind-bucket.s3.us-east-1.amazonaws.com/avatars/avatar-32.png'
  };
  
  // Normalize the type to handle variations
  const normalizedType = type?.toLowerCase().replace(/[-_\s]/g, '');
  
  // Check for exact matches first
  if (images[normalizedType]) {
    return images[normalizedType];
  }
  
  // Check for partial matches
  if (normalizedType.includes('flower') || normalizedType.includes('bud')) {
    return images['flower'];
  }
  if (normalizedType.includes('edible') || normalizedType.includes('gummy') || normalizedType.includes('cookie')) {
    return images['edible'];
  }
  if (normalizedType.includes('cart') || normalizedType.includes('vape')) {
    return images['cart'];
  }
  if (normalizedType.includes('preroll') || normalizedType.includes('joint')) {
    return images['pre-roll'];
  }
  if (normalizedType.includes('concentrate') || normalizedType.includes('wax') || normalizedType.includes('shatter')) {
    return images['concentrate'];
  }
  
  return images['default'];
};